import PropTypes from 'prop-types';
import _ from 'lodash';
import { useFormikContext } from 'formik';
import { useWizardState } from '../WizardContext';
import { useAppContext } from '../../../context/appContext';
import ACTIONS from '../../../context/appActions';

const SubmitButton = ({ children }) => {
  const { isLastPage, currentStep, submitOnStep } = useWizardState();
  const {
    setTouched,
    submitForm,
    validateForm,
    values,
  } = useFormikContext();

  const { dispatch } = useAppContext();

  const handleOnClick = () => {
    validateForm().then((errors) => {
      if (_.isEmpty(errors)) {
        dispatch({ type: ACTIONS.UPDATE_STATE, data: { benefitEstimator: values } });
        submitForm();
      } else {
        setTouched(errors);
      }
    });
  };

  return ((!!submitOnStep && submitOnStep === currentStep) || isLastPage) && children(handleOnClick);
};

SubmitButton.propTypes = {
  children: PropTypes.func.isRequired,
  setTouched: PropTypes.func,
  submitOnStep: PropTypes.number,
  validateForm: PropTypes.func,
};

export default SubmitButton;
